<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
        <text class="me-5">共<span class="fw-bold" style="color: #536fc4">{{count}}</span>个作品</text>
        <text class="me-5">已打分：<span class="fw-bold" style="color: chartreuse">{{countScored}}</span></text>
        <text class="me-3">未打分：<span class="fw-bold" style="color: red">{{countUnscored}}</span></text>
        <text class="text-danger small" v-if="incompleteInfo">提示：您的专家信息未补充完整</text>
      </div>

<!--      <div class="me-3">-->
<!--        <text>共<span class="fw-bold" style="color: #536fc4">{{total}}</span>个作品</text>-->
<!--        <text>已打分：<span class="fw-bold" style="color: chartreuse">{{total}}</span></text>-->
<!--        <text>未打分：<span class="fw-bold" style="color: red">{{total}}</span></text>-->
<!--      </div>-->
    </div>
    <div class="pub-center">
      <el-table scrollbar-always-on border   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="序号" width="60">
          <template #default="scope">
            {{scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column label="阶段"   >
          <template #default="scope">
            {{stage==1?"初赛":"复赛"}}
          </template>
        </el-table-column>
        <el-table-column label="参赛队伍" width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.TeamName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="选题类型" >
          <template #default="scope">
            {{scope.row.TopicName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛作品" width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="队长姓名" >
          <template #default="scope">
            {{scope.row.TeamContact}}
          </template>
        </el-table-column>
<!--        <el-table-column label="作品选题依据和创新性(40)" >-->
<!--          <el-table-column  label="实施方案的可行性，包括设计、制作、试验验证的可行性等；" width="120" >-->
<!--          <template #default="scope">-->
<!--            {{scope.row.ScoreDetailScore1 || '-'}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="可行性和产业化前景(60分)" >-->
<!--          <el-table-column  label="选题是否适应国家重大需求或者面向传感器产业市场需求；" width="120" >-->
<!--            <template #default="scope">-->
<!--              {{scope.row.ScoreDetailScore2 || '-'}}-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table-column>-->
        <el-table-column label="总分" >
          <template #default="scope">
            {{scope.row.ScoreDetailScore || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="推荐等级" >
          <template #default="scope">
            {{scope.row.ScoreDetailLevel || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="状态" >
          <template #default="scope">
           <text v-if="scope.row.ScoreDetailID" style="color: #3f9dfd" >已打分</text>
            <text v-else style="color: red">未打分</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px" fixed="right">
          <template #default="scope">
            <el-button  size="small" type="primary" @click="goScore(scope.$index, scope.row)">打分</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {formatTime} from "@/utils/dateFun";
import {getName, LEVELS} from "@/utils/commonSetting";
import {getWorks} from "@/api/special";
const stage = 1 //1-初赛，2-复赛
const params = reactive({
  pageSize:10,
  current:1,
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
// const works = ref([]) // 作品列表。每个作品包含总分(ScoreDetail.Score)，推荐等级(ScoreDetail.Level)，状态(通过判断 ScoreDetail.ID 是否大于 0，大于 0 代表已打分)
const count= ref(0)// 作品总数
const countScored = ref(0) // 已打分作品数
const countUnscored = ref(0) // 未打分作品数
import { useRouter } from "vue-router";
let router = useRouter();
onMounted(()=>{
  getUserInfo()
  getList()
})
import {useStore} from "vuex";
const store = useStore()
const incompleteInfo = ref(false) // 信息不完成
// 获取用户信息
const getUserInfo = async ()=>{
  incompleteInfo.value = true
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  const u = store.getters["loginModel/getUserInfo"] || {}
  if(!u.real_name || !u.company|| !u.title|| !u.tel|| !u.id_card|| !u.bank_card|| !u.bank_name){
    incompleteInfo.value = true
    // return  ElMessageBox.alert('请补充个人信息后再进行评分，去补充？', '补充信息', {
    //   confirmButtonText: '确定',
    //   callback: (action) => {
    //     if(action==='confirm'){ // 确定
    //       router.push({path:'/special/specialinfo'})
    //     }
    //   },
    // })
  }else{
    incompleteInfo.value = false
  }

}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getWorks({...params,stage:stage})
  loading.value = false
  if(res.err_code === 0){
    let data = res.data || {}
    count.value = data.count || 0
    total.value = data.count || 0
    const works = data.works || []
    countScored.value = data.countScored || 0
    countUnscored.value = data.countUnscored || 0
    works.forEach(item=>{
      // if(item.University){
      //   item.Province = item.University.Province
      //   item.SchoolName = item.University.Name
      // }
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
      if(item.Topic){
        item.TopicName = item.Topic.Name
      }
      if(item.Team){
        item.TeamName = item.Team.Name
        item.TeamContact = item.Team.Contact
        item.TeamPhone = item.Team.Phone
        item.TeamName = item.Team.Name
        if(item.Team.University){
          item.SchoolName = item.Team.University.Name
        }
      }
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
      if(item.ScoreDetail && item.ScoreDetail.ID>0){
        item.ScoreDetailID = item.ScoreDetail.ID
        if(item.ScoreDetail.Detail){
          item.ScoreDetailScore1 = item.ScoreDetail.Detail.split(",")[0]
          item.ScoreDetailScore2 =  item.ScoreDetail.Detail.split(",")[1]
        }
        item.ScoreDetailLevel = item.ScoreDetail.Level
        item.ScoreDetailScore = item.ScoreDetail.Score
      }
    })

    list.value = works
  }else{
    list.value = []
    return  ElMessage.warning(res.err_msg || "获取列表失败")
  }
}


// 查看或打分
const goScore = (index,item)=>{
  const r = router.resolve({path:'/special/entryscoring',query:{id:item.ID,stage:stage}})
  window.open(r.href,"_blank")
}



// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}

</script>

<style scoped lang="scss">


</style>
